import React from 'react';
import PropTypes from 'prop-types';
import style from './style.scss';

const AddToListButton = ({openModalAddToList, itemId, productId}) => {

    return (
        <div className="add-to-list-button">
            <button className="add-to-list-icon" onClick={() => openModalAddToList(itemId || productId)}><i className="jumbo-icon-new-list"></i></button>
        </div>
    )
}

AddToListButton.propTypes = {
    openModalAddToList: PropTypes.func,
    itemId: PropTypes.string,
    productId: PropTypes.string
}

export default AddToListButton;